var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region"},[_c('mtd-icon',{staticClass:"region-icon",attrs:{"name":"mtdicon-location-o"}}),_vm._v(" "),_c('span',{staticClass:"region-text"},[_vm._v(_vm._s(_vm.regionStr))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }